import { Disclosure, DisclosureContent, useDisclosureState } from "ariakit";
import React from "react";
import styled from "styled-components";
import { Icon } from "./Icon";
import { style } from "./style";
import { focusOutline } from "./utils/focusOutlineStyle";

const Trigger = styled(Disclosure)`
  background: none;
  border: none;
  border-radius: ${style.vars.borderRadius.base};
  color: ${style.colors.blue.dark};
  cursor: pointer;
  font-family: inherit;

  &:focus {
    ${focusOutline()};
  }

  &:active,
  &:hover {
    background-color: ${style.colors.grey.lightest};
  }
`;

const TriggerText = styled.label`
  color: inherit;
  cursor: pointer;
  letter-spacing: inherit;
  text-transform: inherit;
  vertical-align: middle;
`;

const TriggerIcon = styled(Icon)`
  cursor: pointer;
  height: ${style.vars.fontSize.base};
  width: ${style.vars.fontSize.base};
  border: ${style.vars.borderWidth.thin} solid;
  border-radius: ${style.vars.borderRadius.base};
  border-color: inherit;
  margin-right: ${style.vars.whitespace.small};
  margin-top: 1px;
  padding: 1px;
  vertical-align: middle;
`;

const Content = styled(DisclosureContent)`
  opacity: 0;
  transition: all ${style.vars.transitionSpeed.base} ease-in-out;

  &[data-enter] {
    opacity: 1;
  }
`;

type CollapsibleContentProps = {
  name: string;
  label?: string;
  initiallyVisible?: boolean;
  children?: React.ReactNode;
};

export const CollapsibleContent: React.FC<CollapsibleContentProps> = ({ name, label, initiallyVisible, children }) => {
  const disclosure = useDisclosureState({
    animated: true,
    open: initiallyVisible,
  });
  return (
    <>
      <Trigger state={disclosure}>
        <TriggerIcon icon={disclosure.open ? "minus" : "plus"} />
        <TriggerText htmlFor={name}>{label}</TriggerText>
      </Trigger>
      <Content state={disclosure}>{children}</Content>
    </>
  );
};
